import { Globe } from "lucide-react";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "./ui/select";
import { useI18n } from "../i18n/I18nContext";
import translations from "../i18n/translations";
import { trackLangChanged } from "../lib/analytics";

export default function LanguageSwitcher({ compact = false }) {
    const { locale, setLocale, locales } = useI18n();

    const onChange = (next) => {
        if (next !== locale) trackLangChanged(locale, next);
        setLocale(next);
    };

    return (
        <Select value={locale} onValueChange={onChange}>
            <SelectTrigger
                data-testid="language-switcher"
                className={`${
                    compact ? "h-9 w-[140px]" : "h-9 w-[150px]"
                } border-slate-200 text-slate-700 hover:bg-slate-100 [&>span]:flex [&>span]:items-center [&>span]:gap-2 text-sm font-medium`}
                aria-label="Language"
            >
                <Globe className="h-4 w-4 text-slate-500 shrink-0" />
                <SelectValue />
            </SelectTrigger>
            <SelectContent align="end">
                {locales.map((l) => {
                    const m = translations[l].meta;
                    return (
                        <SelectItem key={l} value={l} data-testid={`lang-option-${l}`}>
                            <span className="mr-1.5">{m.flag}</span>
                            {m.localeLabel}
                        </SelectItem>
                    );
                })}
            </SelectContent>
        </Select>
    );
}
